<template>
    <CompassPanel :value="true" size="large" :title="value.title" @beforeClose="close">
        <!-- CONTENT -->
        <template slot="default">
            <CompassLoader
                v-if="loading"
                class="overview-panel-container--loader"
                size="large"
                color="sellsy-brand-primary-100"
            />
            <div
                class="overview-panel-container__content"
                :class="{ 'overview-panel-container__content--load': loading }"
            >
                <iframe
                    id="overview-panel-iframe"
                    :src="value.data"
                    width="100%"
                    height="960"
                    type="application/pdf"
                    @load="loaded"
                >
                </iframe>
            </div>
        </template>

        <!-- FOOTER -->
        <template v-if="value.settings" slot="footer">
            <!-- UNLINK -->
            <CompassButton
                v-if="!isMain"
                :loading="isLoading"
                :label="$t.__('common.actions.unlink')"
                type="secondary"
                @click="unlink"
            ></CompassButton>

            <!-- SET AS MAIN DOCUMENT -->
            <CompassButton
                :loading="isLoading"
                :label="$t.__('overview.panels.OverviewPanel.declare_as_main_document')"
                :disabled="isMain"
                type="secondary"
                @click="setMainDocument"
            ></CompassButton>

            <!-- SET AS MAIN DOCUMENT -->
            <CompassButton
                v-if="canSendEmail"
                :loading="isLoading"
                :label="$t.__('overview.panels.OverviewPanel.send_by_mail')"
                @click="send"
            ></CompassButton>
        </template>
    </CompassPanel>
</template>
<script>
import Feature from 'Services/Feature';

export default {
    props: {
        value: {
            type: Object,
            required: true,
        },
        loading: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            localLoader: false,
        };
    },
    computed: {
        isMain() {
            return this.value.settings.isMainDocument;
        },
        isLoading() {
            return this.loading ? this.localLoader : false;
        },
        canSendEmail() {
            return Feature.isEnabled('opportunity-overview-linked-documents-send-email');
        },
    },
    methods: {
        callToast(text, type) {
            this.$pushToast({
                type: type,
                icon: true,
                text: text,
            });
        },
        loaded() {
            this.$emit('loaded');
        },
        close() {
            this.$emit('close');
        },
        send() {
            //TODO : add send email functionnality
            this.close();
        },
        setMainDocument() {
            this.localLoader = true;
            this.$store
                .dispatch('updateMainDocument', this.value.linkId)
                .then(() => {
                    this.callToast(
                        this.$l10n.__('Le document principal a bien été mis à jour.'),
                        'success',
                    );
                    this.$trigger('overview:closePanel');
                })
                .catch(() => {
                    this.callToast(
                        this.$l10n.__(
                            "Une erreur s'est produite lors de la mise à jour du document principal.",
                        ),
                        'error',
                    );
                })
                .finally(() => {
                    this.localLoader = false;
                });
        },

        //Call an intercom dialog
        unlink() {
            window.Opportunity.unlink(this.value.linkId);
        },
    },
};
</script>
<style lang="scss" scoped>
.compass-panel {
    background-color: var(--colors-common-background-default);
    .overview-panel-container {
        &__content {
            position: relative;
            &--load:before {
                content: '';
                display: block;
                position: absolute;
                top: 0;
                bottom: 0;
                right: 0;
                left: 0;
                background: var(--colors-common-background-default);
                opacity: 0.9;
            }
        }
        &--loader {
            z-index: 2;
            position: absolute;
            left: 50%;
            top: 50%;
        }
    }
    &::v-deep .compass-panel__footer {
        display: flex;
        justify-content: end;
        padding: var(--spacing-5);
        border-top: 1px solid var(--colors-common-border-default);
        .compass-button {
            margin-left: var(--spacing-3);
        }
    }
}
</style>
